import { FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

export const AlertIconVariants = {
  information: <FiInfo size={20} />,
  note: <FiInfo size={20} />,
  success: <FiCheckCircle size={20} />,
  warning: <FiAlertCircle size={20} />,
  error: <FiAlertCircle size={20} />,
};
